/**
 * Spotlight global shortcut handler.
 *
 * Bindet Cmd/Ctrl+K an das `open-spotlight` Livewire-Event. Wird über
 * `resources/js/app.js` in das Haupt-Bundle gebaut und auf jeder Seite
 * (eingeloggt oder nicht) geladen — die Modal-Komponente selbst rendert
 * jedoch nur im `@auth`-Block, dispatch ohne aktive Komponente ist ein No-Op.
 *
 * Designentscheidungen:
 * - Cmd+F (Browser-Find) bleibt unangetastet — nur Cmd/Ctrl+K wird abgefangen.
 * - Auch in Input-Feldern auslösbar (Spotlight ist global und soll überall
 *   verfügbar sein).
 * - `?` als Shortcut wäre eine Option für nicht-Mac-User, kollidiert aber
 *   mit Eingaben — nicht in Phase 1.
 */

function isShortcut(event) {
    if (event.key !== 'k' && event.key !== 'K') {
        return false;
    }
    // Mac: metaKey (Cmd), sonst ctrlKey
    return event.metaKey || event.ctrlKey;
}

function dispatchOpen() {
    if (typeof window.Livewire === 'undefined' || typeof window.Livewire.dispatch !== 'function') {
        return;
    }
    window.Livewire.dispatch('open-spotlight');
}

document.addEventListener('keydown', function (event) {
    if (!isShortcut(event)) {
        return;
    }
    event.preventDefault();
    event.stopPropagation();
    dispatchOpen();
}, true);
